(() => {
    const COUNTRY_LOCALES = {
        AE: "ar-AE",
        AT: "de-AT",
        AU: "en-AU",
        BE: "nl-BE",
        BR: "pt-BR",
        CA: "en-CA",
        CH: "de-CH",
        CL: "es-CL",
        CN: "zh-CN",
        DE: "de-DE",
        DK: "da-DK",
        ES: "es-ES",
        FI: "fi-FI",
        FR: "fr-FR",
        GB: "en-GB",
        GR: "el-GR",
        HK: "en-HK",
        HU: "hu-HU",
        ID: "id-ID",
        IE: "en-IE",
        IN: "en-IN",
        IT: "it-IT",
        JP: "ja-JP",
        LU: "fr-LU",
        MX: "es-MX",
        MY: "ms-MY",
        NL: "nl-NL",
        NZ: "en-NZ",
        PH: "en-PH",
        PT: "pt-PT",
        SE: "sv-SE",
        SG: "en-SG",
        TH: "th-TH",
        TW: "zh-TW",
        US: "en-US",
        VN: "vi-VN",
    };

    const getLocale = () => {
        const { country, locale } = window.Shopify || {};

        return (
            COUNTRY_LOCALES[country] ||
            (country && locale ? `${locale}-${country}` : null) ||
            locale ||
            "en-US"
        );
    };

    const formatMoney = (amount) => {
        const value = Number(amount);

        if (!Number.isFinite(value)) {
            return "";
        }

        const moneyFormat = window.theme?.moneyFormat;
        const currency = window.Shopify?.currency?.active;

        if (!currency) {
            return String(amount);
        }

        const noDecimals = moneyFormat?.includes("no_decimals");

        const formattedAmount = new Intl.NumberFormat(
            getLocale(),
            {
                style: "decimal",
                minimumFractionDigits: noDecimals ? 0 : 2,
                maximumFractionDigits: noDecimals ? 0 : 2,
            }
        ).format(value / 100);

        if (!moneyFormat) {
            return new Intl.NumberFormat(getLocale(), {
                style: "currency",
                currency,
                currencyDisplay: "narrowSymbol",
                minimumFractionDigits: noDecimals ? 0 : 2,
                maximumFractionDigits: noDecimals ? 0 : 2,
            }).format(value / 100);
        }

        return moneyFormat.replace(
            /\{\{(?:amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator|amount_with_apostrophe_separator|amount_no_decimals_with_apostrophe_separator)\}\}/,
            formattedAmount
        );
    };

    window.Utils = {
        formatMoney,
    };
})();